import { computed, inject, Injectable, signal } from '@angular/core';
import { SearchCatalogRequest } from '../../rewards/interfaces/search-catalog-request.interface';
import { Subject } from 'rxjs';
import { PointFilter } from '../../rewards/enums/point-filter.enum';
import { UserDataService } from './user-data.service';

@Injectable({ providedIn: 'root' })
export class CatalogDataService {
  private readonly INITIAL_CATALOG: SearchCatalogRequest = {
    page: 1,
    pageSize: 16,
  };

  userDataService = inject(UserDataService);

  private _filter = signal<SearchCatalogRequest>({ ...this.INITIAL_CATALOG });
  filter = computed(() => this._filter());
  clearFilters$ = new Subject<void>();

  setCategory(categoryId: string) {
    this._filter.update(current => ({
      ...current,
      categoryId,
      page: 1,
    }));
  }

  setSearch(search: string) {
    this._filter.update((current) => ({
      ...current,
      search,
      page: 1,
    }));
  }

  setSort(sortById: string) {
    this._filter.update((current) => ({
      ...current,
      sortById,
      page: 1,
    }));
  }

  setFilter(pointFilterId: string) {
    this._filter.update((current) => {
      delete current.minimumPoints;
      delete current.maximumPoints;

      return {
        ...current,
        pointFilterId,
        page: 1,
        points: this.userDataService.userData()?.balance ?? 0,
      };
    });
  }

  setFilterByPoints(minimumPoints: number, maximumPoints: number) {
    this._filter.update((current) => ({
      ...current,
      pointFilterId: PointFilter.ByPointsRange,
      minimumPoints,
      maximumPoints,
      page: 1,
    }));
  }

  viewMore() {
    this._filter.update((current) => ({
      ...current,
      page: current.page + 1,
    }));
  }

  resetFilter() {
    this._filter.set({ ...this.INITIAL_CATALOG });
  }
}
